'use strict';
require('../../modules/es.string.repeat');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'repeat');
